/* DO NOT EDIT!
   This file is generated from: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/client/localeProperties/abweb_en.properties
   To regenerate after edits to the above file, invoke the module's package.json task: locale:regen:maven
   Also helpful: https://confluence.abinitio.com/display/FED/Localization+for+Developers
*/// eslint-disable
import{AbWebServices}from"abweb/service/AbWebServices";/**
 * <pre>
 * about=About WebApp
 * </pre>
 */export function about(){return AbWebServices.i18n.getMessage("abweb","about");}/**
 * <pre>
 * about.dialog.copyright.notice=Copyright © 1996-2026 Ab Initio
UNPUBLISHED -- ALL RIGHTS RESERVED
 * </pre>
 */export function about_dialog_copyright_notice(){return AbWebServices.i18n.getMessage("abweb","about.dialog.copyright.notice");}/**
 * <pre>
 * about.dialog.legalBoilerplate=USE AND DISCLOSURE IS RESTRICTED BY LICENSE CONDITIONS.

This program is confidential and a trade secret of Ab Initio.
Provision, receipt or possession convey no ownership, usage or other rights for any purpose without specific written declaration from Ab Initio.
 * </pre>
 */export function about_dialog_legalBoilerplate(){return AbWebServices.i18n.getMessage("abweb","about.dialog.legalBoilerplate");}/**
 * <pre>
 * about.dialog.product.versions=Product Versions
 * </pre>
 */export function about_dialog_product_versions(){return AbWebServices.i18n.getMessage("abweb","about.dialog.product.versions");}/**
 * <pre>
 * accessDeniedDlg.error=Access Denied. Your account has not been granted access to this resource. Please contact your system administrator or try again.
 * </pre>
 */export function accessDeniedDlg_error(){return AbWebServices.i18n.getMessage("abweb","accessDeniedDlg.error");}/**
 * <pre>
 * # Arg 0 is the username
 * activeUserCmp.loggedInAs=Logged in as {0}
 * </pre>
 */export function activeUserCmp_loggedInAs(arg0){return AbWebServices.i18n.getMessage("abweb","activeUserCmp.loggedInAs",arg0);}/**
 * <pre>
 * activeUserCmp.optionsMenu=Options
 * </pre>
 */export function activeUserCmp_optionsMenu(){return AbWebServices.i18n.getMessage("abweb","activeUserCmp.optionsMenu");}/**
 * <pre>
 * add=Add
 * </pre>
 */export function add(){return AbWebServices.i18n.getMessage("abweb","add");}/**
 * <pre>
 * addNew=Add New
 * </pre>
 */export function addNew(){return AbWebServices.i18n.getMessage("abweb","addNew");}/**
 * <pre>
 * apply=Apply
 * </pre>
 */export function apply(){return AbWebServices.i18n.getMessage("abweb","apply");}/**
 * <pre>
 * apply.next=Apply and Go To Next
 * </pre>
 */export function apply_next(){return AbWebServices.i18n.getMessage("abweb","apply.next");}/**
 * <pre>
 * button.view=View
 * </pre>
 */export function button_view(){return AbWebServices.i18n.getMessage("abweb","button.view");}/**
 * <pre>
 * cancel=Cancel
 * </pre>
 */export function cancel(){return AbWebServices.i18n.getMessage("abweb","cancel");}/**
 * <pre>
 * changePasswordSuccessful=The password has been updated.
 * </pre>
 */export function changePasswordSuccessful(){return AbWebServices.i18n.getMessage("abweb","changePasswordSuccessful");}/**
 * <pre>
 * clear=Clear
 * </pre>
 */export function clear(){return AbWebServices.i18n.getMessage("abweb","clear");}/**
 * <pre>
 * clientFilterCmp.between=Is between
 * </pre>
 */export function clientFilterCmp_between(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.between");}/**
 * <pre>
 * clientFilterCmp.greaterThan=Is greater than
 * </pre>
 */export function clientFilterCmp_greaterThan(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.greaterThan");}/**
 * <pre>
 * clientFilterCmp.greaterThanOrEqual=Is greater than or equal to
 * </pre>
 */export function clientFilterCmp_greaterThanOrEqual(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.greaterThanOrEqual");}/**
 * <pre>
 * clientFilterCmp.is=Equals
 * </pre>
 */export function clientFilterCmp_is(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.is");}/**
 * <pre>
 * clientFilterCmp.isNot=Is not equal to
 * </pre>
 */export function clientFilterCmp_isNot(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.isNot");}/**
 * <pre>
 * clientFilterCmp.isNotNull=Is present
 * </pre>
 */export function clientFilterCmp_isNotNull(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.isNotNull");}/**
 * <pre>
 * clientFilterCmp.isNull=Is not present
 * </pre>
 */export function clientFilterCmp_isNull(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.isNull");}/**
 * <pre>
 * clientFilterCmp.lessThan=Is less than
 * </pre>
 */export function clientFilterCmp_lessThan(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.lessThan");}/**
 * <pre>
 * clientFilterCmp.lessThanOrEqual=Is less than or equal to
 * </pre>
 */export function clientFilterCmp_lessThanOrEqual(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.lessThanOrEqual");}/**
 * <pre>
 * clientFilterCmp.stringBeginsWith=Starts with
 * </pre>
 */export function clientFilterCmp_stringBeginsWith(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.stringBeginsWith");}/**
 * <pre>
 * clientFilterCmp.stringContains=Contains
 * </pre>
 */export function clientFilterCmp_stringContains(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.stringContains");}/**
 * <pre>
 * clientFilterCmp.stringEndsWith=Ends with
 * </pre>
 */export function clientFilterCmp_stringEndsWith(){return AbWebServices.i18n.getMessage("abweb","clientFilterCmp.stringEndsWith");}/**
 * <pre>
 * close=Close
 * </pre>
 */export function close(){return AbWebServices.i18n.getMessage("abweb","close");}/**
 * <pre>
 * copy=Copy
 * </pre>
 */export function copy(){return AbWebServices.i18n.getMessage("abweb","copy");}/**
 * <pre>
 * copy.copyToClipboard=Copy to Clipboard
 * </pre>
 */export function copy_copyToClipboard(){return AbWebServices.i18n.getMessage("abweb","copy.copyToClipboard");}/**
 * <pre>
 * dataGrid.pasteError=Error pasting data. Not all data may have been pasted successfully.
{0}
 * </pre>
 */export function dataGrid_pasteError(arg0){return AbWebServices.i18n.getMessage("abweb","dataGrid.pasteError",arg0);}/**
 * <pre>
 * dataSourceGridAdapter.recordAddedLocalTooltip=Record is added but not saved yet.
 * </pre>
 */export function dataSourceGridAdapter_recordAddedLocalTooltip(){return AbWebServices.i18n.getMessage("abweb","dataSourceGridAdapter.recordAddedLocalTooltip");}/**
 * <pre>
 * dataSourceGridAdapter.recordAddedTooltip=Record is added but not committed yet.
 * </pre>
 */export function dataSourceGridAdapter_recordAddedTooltip(){return AbWebServices.i18n.getMessage("abweb","dataSourceGridAdapter.recordAddedTooltip");}/**
 * <pre>
 * dataSourceGridAdapter.recordDeletedLocalTooltip=Record is marked for delete but not saved yet.
 * </pre>
 */export function dataSourceGridAdapter_recordDeletedLocalTooltip(){return AbWebServices.i18n.getMessage("abweb","dataSourceGridAdapter.recordDeletedLocalTooltip");}/**
 * <pre>
 * dataSourceGridAdapter.recordDeletedTooltip=Record is deleted but not committed yet.
 * </pre>
 */export function dataSourceGridAdapter_recordDeletedTooltip(){return AbWebServices.i18n.getMessage("abweb","dataSourceGridAdapter.recordDeletedTooltip");}/**
 * <pre>
 * dataSourceGridAdapter.recordModifiedTooltip=Record is modified.
 * </pre>
 */export function dataSourceGridAdapter_recordModifiedTooltip(){return AbWebServices.i18n.getMessage("abweb","dataSourceGridAdapter.recordModifiedTooltip");}/**
 * <pre>
 * dataSourceRecord.invalid=Record contains validation errors.
 * </pre>
 */export function dataSourceRecord_invalid(){return AbWebServices.i18n.getMessage("abweb","dataSourceRecord.invalid");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.appendChildRow=Append child row
 * </pre>
 */export function dataSourceRowHeaderRenderer_appendChildRow(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.appendChildRow");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.deleteRows=Delete rows
 * </pre>
 */export function dataSourceRowHeaderRenderer_deleteRows(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.deleteRows");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.indentRows=Indent rows
 * </pre>
 */export function dataSourceRowHeaderRenderer_indentRows(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.indentRows");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.insertRowsAbove=Insert rows above
 * </pre>
 */export function dataSourceRowHeaderRenderer_insertRowsAbove(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.insertRowsAbove");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.insertRowsBelow=Insert rows below
 * </pre>
 */export function dataSourceRowHeaderRenderer_insertRowsBelow(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.insertRowsBelow");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.lockedRecord=Record is locked and cannot be edited.
 * </pre>
 */export function dataSourceRowHeaderRenderer_lockedRecord(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.lockedRecord");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.moveRows=Move rows
 * </pre>
 */export function dataSourceRowHeaderRenderer_moveRows(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.moveRows");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.outdentRows=Outdent rows
 * </pre>
 */export function dataSourceRowHeaderRenderer_outdentRows(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.outdentRows");}/**
 * <pre>
 * dataSourceRowHeaderRenderer.revertChanges=Revert changes
 * </pre>
 */export function dataSourceRowHeaderRenderer_revertChanges(){return AbWebServices.i18n.getMessage("abweb","dataSourceRowHeaderRenderer.revertChanges");}/**
 * <pre>
 * # Baseline vs. tip value. Call baseline value "Previous value".
 * dataSourceValueRenderer.changes1=Previous value:
{0}
 * </pre>
 */export function dataSourceValueRenderer_changes1(arg0){return AbWebServices.i18n.getMessage("abweb","dataSourceValueRenderer.changes1",arg0);}/**
 * <pre>
 * # Changeset vs. local change. Call changeset value "Previous value".
 * dataSourceValueRenderer.changes1a=Previous value:
{0}
 * </pre>
 */export function dataSourceValueRenderer_changes1a(arg0){return AbWebServices.i18n.getMessage("abweb","dataSourceValueRenderer.changes1a",arg0);}/**
 * <pre>
 * # Baseline vs. changeset vs. local change. Call baseline value "Published value".
 * dataSourceValueRenderer.changes2=Changeset value:
{0}

Published value:
{1}
 * </pre>
 */export function dataSourceValueRenderer_changes2(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","dataSourceValueRenderer.changes2",arg0,arg1);}/**
 * <pre>
 * dataSourceValueRenderer.limitedTextLessLink=... less
 * </pre>
 */export function dataSourceValueRenderer_limitedTextLessLink(){return AbWebServices.i18n.getMessage("abweb","dataSourceValueRenderer.limitedTextLessLink");}/**
 * <pre>
 * dataSourceValueRenderer.limitedTextMoreLink=... more
 * </pre>
 */export function dataSourceValueRenderer_limitedTextMoreLink(){return AbWebServices.i18n.getMessage("abweb","dataSourceValueRenderer.limitedTextMoreLink");}/**
 * <pre>
 * dateFormatDayAgo={0} day ago
 * </pre>
 */export function dateFormatDayAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatDayAgo",arg0);}/**
 * <pre>
 * dateFormatDaysAgo={0} days ago
 * </pre>
 */export function dateFormatDaysAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatDaysAgo",arg0);}/**
 * <pre>
 * dateFormatDaysAgo.abbreviated={0}d ago
 * </pre>
 */export function dateFormatDaysAgo_abbreviated(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatDaysAgo.abbreviated",arg0);}/**
 * <pre>
 * dateFormatHourAgo={0} hour ago
 * </pre>
 */export function dateFormatHourAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatHourAgo",arg0);}/**
 * <pre>
 * dateFormatHoursAgo={0} hours ago
 * </pre>
 */export function dateFormatHoursAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatHoursAgo",arg0);}/**
 * <pre>
 * dateFormatHoursAgo.abbreviated={0}h ago
 * </pre>
 */export function dateFormatHoursAgo_abbreviated(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatHoursAgo.abbreviated",arg0);}/**
 * <pre>
 * dateFormatMinuteAgo={0} minute ago
 * </pre>
 */export function dateFormatMinuteAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatMinuteAgo",arg0);}/**
 * <pre>
 * dateFormatMinutesAgo={0} minutes ago
 * </pre>
 */export function dateFormatMinutesAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatMinutesAgo",arg0);}/**
 * <pre>
 * dateFormatMinutesAgo.abbreviated={0}m ago
 * </pre>
 */export function dateFormatMinutesAgo_abbreviated(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatMinutesAgo.abbreviated",arg0);}/**
 * <pre>
 * dateFormatMomentsAgo=Just now
 * </pre>
 */export function dateFormatMomentsAgo(){return AbWebServices.i18n.getMessage("abweb","dateFormatMomentsAgo");}/**
 * <pre>
 * dateFormatMonthAgo={0} month ago
 * </pre>
 */export function dateFormatMonthAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatMonthAgo",arg0);}/**
 * <pre>
 * dateFormatMonthsAgo={0} months ago
 * </pre>
 */export function dateFormatMonthsAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatMonthsAgo",arg0);}/**
 * <pre>
 * dateFormatMonthsAgo.abbreviated={0}mo ago
 * </pre>
 */export function dateFormatMonthsAgo_abbreviated(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatMonthsAgo.abbreviated",arg0);}/**
 * <pre>
 * dateFormatSecondAgo={0} second ago
 * </pre>
 */export function dateFormatSecondAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatSecondAgo",arg0);}/**
 * <pre>
 * dateFormatSecondsAgo={0} seconds ago
 * </pre>
 */export function dateFormatSecondsAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatSecondsAgo",arg0);}/**
 * <pre>
 * dateFormatSecondsAgo.abbreviated={0}s ago
 * </pre>
 */export function dateFormatSecondsAgo_abbreviated(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatSecondsAgo.abbreviated",arg0);}/**
 * <pre>
 * dateFormatToday=Today
 * </pre>
 */export function dateFormatToday(){return AbWebServices.i18n.getMessage("abweb","dateFormatToday");}/**
 * <pre>
 * dateFormatWeeksAgo.abbreviated={0}w ago
 * </pre>
 */export function dateFormatWeeksAgo_abbreviated(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatWeeksAgo.abbreviated",arg0);}/**
 * <pre>
 * dateFormatYearAgo={0} year ago
 * </pre>
 */export function dateFormatYearAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatYearAgo",arg0);}/**
 * <pre>
 * dateFormatYearAgo.abbreviated=1y ago
 * </pre>
 */export function dateFormatYearAgo_abbreviated(){return AbWebServices.i18n.getMessage("abweb","dateFormatYearAgo.abbreviated");}/**
 * <pre>
 * dateFormatYearsAgo={0} years ago
 * </pre>
 */export function dateFormatYearsAgo(arg0){return AbWebServices.i18n.getMessage("abweb","dateFormatYearsAgo",arg0);}/**
 * <pre>
 * dateFormatYearsAgo.abbreviated=1y+ ago
 * </pre>
 */export function dateFormatYearsAgo_abbreviated(){return AbWebServices.i18n.getMessage("abweb","dateFormatYearsAgo.abbreviated");}/**
 * <pre>
 * dateFormatYesterday=Yesterday
 * </pre>
 */export function dateFormatYesterday(){return AbWebServices.i18n.getMessage("abweb","dateFormatYesterday");}/**
 * <pre>
 * diagram.toggleThumbnailView=Toggle thumbnail view
 * </pre>
 */export function diagram_toggleThumbnailView(){return AbWebServices.i18n.getMessage("abweb","diagram.toggleThumbnailView");}/**
 * <pre>
 * # direct translations for general use "direct.*"
 * direct.refresh=Refresh
 * </pre>
 */export function direct_refresh(){return AbWebServices.i18n.getMessage("abweb","direct.refresh");}/**
 * <pre>
 * discard=Discard
 * </pre>
 */export function discard(){return AbWebServices.i18n.getMessage("abweb","discard");}/**
 * <pre>
 * # document resources. For example, application configurations or rulesets can be locked, refreshed, etc.
 * document.lock=Lock
 * </pre>
 */export function document_lock(){return AbWebServices.i18n.getMessage("abweb","document.lock");}/**
 * <pre>
 * document.refresh=Refresh
 * </pre>
 */export function document_refresh(){return AbWebServices.i18n.getMessage("abweb","document.refresh");}/**
 * <pre>
 * download.cancelled=Download cancelled.
 * </pre>
 */export function download_cancelled(){return AbWebServices.i18n.getMessage("abweb","download.cancelled");}/**
 * <pre>
 * download.complete={0} bytes written to {1}.
 * </pre>
 */export function download_complete(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","download.complete",arg0,arg1);}/**
 * <pre>
 * download.defaultStatusMessage=Preparing data for download...
 * </pre>
 */export function download_defaultStatusMessage(){return AbWebServices.i18n.getMessage("abweb","download.defaultStatusMessage");}/**
 * <pre>
 * download.defaultTargetName=download
 * </pre>
 */export function download_defaultTargetName(){return AbWebServices.i18n.getMessage("abweb","download.defaultTargetName");}/**
 * <pre>
 * download.defaultTitle=Download
 * </pre>
 */export function download_defaultTitle(){return AbWebServices.i18n.getMessage("abweb","download.defaultTitle");}/**
 * <pre>
 * download.progress={0} bytes written to {1}...
 * </pre>
 */export function download_progress(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","download.progress",arg0,arg1);}/**
 * <pre>
 * edit=Edit
 * </pre>
 */export function edit(){return AbWebServices.i18n.getMessage("abweb","edit");}/**
 * <pre>
 * error=Error
 * </pre>
 */export function error(){return AbWebServices.i18n.getMessage("abweb","error");}/**
 * <pre>
 * error.fatal=Fatal Error
 * </pre>
 */export function error_fatal(){return AbWebServices.i18n.getMessage("abweb","error.fatal");}/**
 * <pre>
 * error.illegalArgumentError=Argument {0} has illegal value: {1}
 * </pre>
 */export function error_illegalArgumentError(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","error.illegalArgumentError",arg0,arg1);}/**
 * <pre>
 * error.illegalStateError=Illegal state: {0}
 * </pre>
 */export function error_illegalStateError(arg0){return AbWebServices.i18n.getMessage("abweb","error.illegalStateError",arg0);}/**
 * <pre>
 * # A generic message used whenever a null value has been found in the TS code. Ideally this error should not happen
 * # in production. There really isn't anything the customer can do about it other than file an SR. If this error shows up
 * # it is most likely a bug in the code.
 * error.unexpected.nullValueFound=An unexpected null value was found.
 * </pre>
 */export function error_unexpected_nullValueFound(){return AbWebServices.i18n.getMessage("abweb","error.unexpected.nullValueFound");}/**
 * <pre>
 * error.uninitializedError=Object used before being initialized: {0}
 * </pre>
 */export function error_uninitializedError(arg0){return AbWebServices.i18n.getMessage("abweb","error.uninitializedError",arg0);}/**
 * <pre>
 * executable.enum.ContinuousGraph.label=Continuous Graph
 * </pre>
 */export function executable_enum_continuousGraph_label(){return AbWebServices.i18n.getMessage("abweb","executable.enum.ContinuousGraph.label");}/**
 * <pre>
 * executable.enum.FsProgram.label=FS Program
 * </pre>
 */export function executable_enum_fsProgram_label(){return AbWebServices.i18n.getMessage("abweb","executable.enum.FsProgram.label");}/**
 * <pre>
 * executable.enum.Graph.label=Graph
 * </pre>
 */export function executable_enum_graph_label(){return AbWebServices.i18n.getMessage("abweb","executable.enum.Graph.label");}/**
 * <pre>
 * executable.enum.MicroGraph.label=Micrograph
 * </pre>
 */export function executable_enum_microGraph_label(){return AbWebServices.i18n.getMessage("abweb","executable.enum.MicroGraph.label");}/**
 * <pre>
 * executable.enum.MpxGraph.label=Mpx Graph
 * </pre>
 */export function executable_enum_mpxGraph_label(){return AbWebServices.i18n.getMessage("abweb","executable.enum.MpxGraph.label");}/**
 * <pre>
 * executable.enum.Plan.label=Plan
 * </pre>
 */export function executable_enum_plan_label(){return AbWebServices.i18n.getMessage("abweb","executable.enum.Plan.label");}/**
 * <pre>
 * executable.enum.Program.label=Program
 * </pre>
 */export function executable_enum_program_label(){return AbWebServices.i18n.getMessage("abweb","executable.enum.Program.label");}/**
 * <pre>
 * executable.label=Executable
 * </pre>
 */export function executable_label(){return AbWebServices.i18n.getMessage("abweb","executable.label");}/**
 * <pre>
 * executable.label.colon=Executable:
 * </pre>
 */export function executable_label_colon(){return AbWebServices.i18n.getMessage("abweb","executable.label.colon");}/**
 * <pre>
 * executable.path.label=Executable path
 * </pre>
 */export function executable_path_label(){return AbWebServices.i18n.getMessage("abweb","executable.path.label");}/**
 * <pre>
 * executable.path.label.colon=Executable path:
 * </pre>
 */export function executable_path_label_colon(){return AbWebServices.i18n.getMessage("abweb","executable.path.label.colon");}/**
 * <pre>
 * executable.title=Executable
 * </pre>
 */export function executable_title(){return AbWebServices.i18n.getMessage("abweb","executable.title");}/**
 * <pre>
 * executable.type.label=Executable type
 * </pre>
 */export function executable_type_label(){return AbWebServices.i18n.getMessage("abweb","executable.type.label");}/**
 * <pre>
 * executable.type.label.colon=Executable type:
 * </pre>
 */export function executable_type_label_colon(){return AbWebServices.i18n.getMessage("abweb","executable.type.label.colon");}/**
 * <pre>
 * failed=Failed
 * </pre>
 */export function failed(){return AbWebServices.i18n.getMessage("abweb","failed");}/**
 * <pre>
 * failed.to.fetch.message=The server cannot be reached
 * </pre>
 */export function failed_to_fetch_message(){return AbWebServices.i18n.getMessage("abweb","failed.to.fetch.message");}/**
 * <pre>
 * failed.to.fetch.title=Failed to fetch
 * </pre>
 */export function failed_to_fetch_title(){return AbWebServices.i18n.getMessage("abweb","failed.to.fetch.title");}/**
 * <pre>
 * fallbackErrorDetails=No error details available.
 * </pre>
 */export function fallbackErrorDetails(){return AbWebServices.i18n.getMessage("abweb","fallbackErrorDetails");}/**
 * <pre>
 * fallbackErrorMessage=An unexpected error occurred.
 * </pre>
 */export function fallbackErrorMessage(){return AbWebServices.i18n.getMessage("abweb","fallbackErrorMessage");}/**
 * <pre>
 * fallbackErrorTitle=Error
 * </pre>
 */export function fallbackErrorTitle(){return AbWebServices.i18n.getMessage("abweb","fallbackErrorTitle");}/**
 * <pre>
 * fetchError.failedToFetch=Failed to fetch
 * </pre>
 */export function fetchError_failedToFetch(){return AbWebServices.i18n.getMessage("abweb","fetchError.failedToFetch");}/**
 * <pre>
 * fetchError.noResponseHeader=No '{0}' response header received for url: {1}
 * </pre>
 */export function fetchError_noResponseHeader(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","fetchError.noResponseHeader",arg0,arg1);}/**
 * <pre>
 * fetchError.receivedBadJsonResponse=Expected json response to either have Content-Type header that contains 'application/json', or for the response body to be empty.  However, received response with 'Content-Type' header: '{0}' and response body length: {1}
 * </pre>
 */export function fetchError_receivedBadJsonResponse(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","fetchError.receivedBadJsonResponse",arg0,arg1);}/**
 * <pre>
 * fetchError.unableAbleToParseRemoveAbInitioErrorException=Unable to parse RemoteAbInitioErrorException from following payload: "{0}"
 * </pre>
 */export function fetchError_unableAbleToParseRemoveAbInitioErrorException(arg0){return AbWebServices.i18n.getMessage("abweb","fetchError.unableAbleToParseRemoveAbInitioErrorException",arg0);}/**
 * <pre>
 * fetchError.unableAbleToParseResponse=Failed to parse server error from response
 * </pre>
 */export function fetchError_unableAbleToParseResponse(){return AbWebServices.i18n.getMessage("abweb","fetchError.unableAbleToParseResponse");}/**
 * <pre>
 * fetchError.unableToReadResponse=Error reading from response
 * </pre>
 */export function fetchError_unableToReadResponse(){return AbWebServices.i18n.getMessage("abweb","fetchError.unableToReadResponse");}/**
 * <pre>
 * fetchError.unexpectedServerResponse=Unexpected server response
 * </pre>
 */export function fetchError_unexpectedServerResponse(){return AbWebServices.i18n.getMessage("abweb","fetchError.unexpectedServerResponse");}/**
 * <pre>
 * finish=Finish
 * </pre>
 */export function finish(){return AbWebServices.i18n.getMessage("abweb","finish");}/**
 * <pre>
 * ### Generic Error Messages ###
 * generic.error=Error
 * </pre>
 */export function generic_error(){return AbWebServices.i18n.getMessage("abweb","generic.error");}/**
 * <pre>
 * genericErrorBody={0}

Details:
{1}
 * </pre>
 */export function genericErrorBody(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","genericErrorBody",arg0,arg1);}/**
 * <pre>
 * graphViewCmp.backwardLineageWalkAction=Walk Lineage Backward
 * </pre>
 */export function graphViewCmp_backwardLineageWalkAction(){return AbWebServices.i18n.getMessage("abweb","graphViewCmp.backwardLineageWalkAction");}/**
 * <pre>
 * graphViewCmp.forwardLineageWalkAction=Walk Lineage Forward
 * </pre>
 */export function graphViewCmp_forwardLineageWalkAction(){return AbWebServices.i18n.getMessage("abweb","graphViewCmp.forwardLineageWalkAction");}/**
 * <pre>
 * graphViewCmp.noObjectsInViewWarning=No objects associated with this view.
 * </pre>
 */export function graphViewCmp_noObjectsInViewWarning(){return AbWebServices.i18n.getMessage("abweb","graphViewCmp.noObjectsInViewWarning");}/**
 * <pre>
 * help=Help
 * </pre>
 */export function help(){return AbWebServices.i18n.getMessage("abweb","help");}/**
 * <pre>
 * hideDetails=Hide Details
 * </pre>
 */export function hideDetails(){return AbWebServices.i18n.getMessage("abweb","hideDetails");}/**
 * <pre>
 * info=Info
 * </pre>
 */export function info(){return AbWebServices.i18n.getMessage("abweb","info");}/**
 * <pre>
 * invalidNumberFormat=Invalid number format
 * </pre>
 */export function invalidNumberFormat(){return AbWebServices.i18n.getMessage("abweb","invalidNumberFormat");}/**
 * <pre>
 * issues.enum.error.label=Error
 * </pre>
 */export function issues_enum_error_label(){return AbWebServices.i18n.getMessage("abweb","issues.enum.error.label");}/**
 * <pre>
 * issues.enum.fatal.label=Critical
 * </pre>
 */export function issues_enum_fatal_label(){return AbWebServices.i18n.getMessage("abweb","issues.enum.fatal.label");}/**
 * <pre>
 * issues.enum.none.label=No issues
 * </pre>
 */export function issues_enum_none_label(){return AbWebServices.i18n.getMessage("abweb","issues.enum.none.label");}/**
 * <pre>
 * issues.enum.warn.label=Warning
 * </pre>
 */export function issues_enum_warn_label(){return AbWebServices.i18n.getMessage("abweb","issues.enum.warn.label");}/**
 * <pre>
 * issues.label=Issues
 * </pre>
 */export function issues_label(){return AbWebServices.i18n.getMessage("abweb","issues.label");}/**
 * <pre>
 * issues.predicted.label=Predicted issues
 * </pre>
 */export function issues_predicted_label(){return AbWebServices.i18n.getMessage("abweb","issues.predicted.label");}/**
 * <pre>
 * issues.predicted.title=Predicted Issues
 * </pre>
 */export function issues_predicted_title(){return AbWebServices.i18n.getMessage("abweb","issues.predicted.title");}/**
 * <pre>
 * issues.title=Issues
 * </pre>
 */export function issues_title(){return AbWebServices.i18n.getMessage("abweb","issues.title");}/**
 * <pre>
 * job.status.enum.jobEventLauncherInitializing.toolTip=Launcher pod initializing
 * </pre>
 */export function job_status_enum_jobEventLauncherInitializing_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobEventLauncherInitializing.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusCompleted.label=Completed
 * </pre>
 */export function job_status_enum_jobStatusCompleted_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusCompleted.label");}/**
 * <pre>
 * job.status.enum.jobStatusCompleted.toolTip=Exited, but did not report its status
 * </pre>
 */export function job_status_enum_jobStatusCompleted_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusCompleted.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusDisabled.label=Disabled
 * </pre>
 */export function job_status_enum_jobStatusDisabled_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusDisabled.label");}/**
 * <pre>
 * job.status.enum.jobStatusDisabled.toolTip=Disabled
 * </pre>
 */export function job_status_enum_jobStatusDisabled_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusDisabled.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusFailure.label=Failed or killed
 * </pre>
 */export function job_status_enum_jobStatusFailure_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusFailure.label");}/**
 * <pre>
 * job.status.enum.jobStatusFailure.toolTip=Failed or killed
 * </pre>
 */export function job_status_enum_jobStatusFailure_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusFailure.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusInitializing.label=Launcher initializing
 * </pre>
 */export function job_status_enum_jobStatusInitializing_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusInitializing.label");}/**
 * <pre>
 * job.status.enum.jobStatusInitializing.toolTip=Launcher initializing
 * </pre>
 */export function job_status_enum_jobStatusInitializing_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusInitializing.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusMarkedAsFailed.label=Marked As Failed
 * </pre>
 */export function job_status_enum_jobStatusMarkedAsFailed_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusMarkedAsFailed.label");}/**
 * <pre>
 * job.status.enum.jobStatusMarkedAsFailed.toolTip=Marked As Failed
 * </pre>
 */export function job_status_enum_jobStatusMarkedAsFailed_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusMarkedAsFailed.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusMarkedAsSuccess.label=Marked As Succeeded
 * </pre>
 */export function job_status_enum_jobStatusMarkedAsSuccess_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusMarkedAsSuccess.label");}/**
 * <pre>
 * job.status.enum.jobStatusMarkedAsSuccess.toolTip=Marked As Succeeded
 * </pre>
 */export function job_status_enum_jobStatusMarkedAsSuccess_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusMarkedAsSuccess.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusOnHold.label=On Hold
 * </pre>
 */export function job_status_enum_jobStatusOnHold_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusOnHold.label");}/**
 * <pre>
 * job.status.enum.jobStatusOnHold.toolTip=On Hold
 * </pre>
 */export function job_status_enum_jobStatusOnHold_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusOnHold.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusReady.label=Ready
 * </pre>
 */export function job_status_enum_jobStatusReady_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusReady.label");}/**
 * <pre>
 * job.status.enum.jobStatusReady.toolTip=Waiting...
 * </pre>
 */export function job_status_enum_jobStatusReady_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusReady.toolTip");}/**
 * <pre>
 * # 'Redacted' means that what would be displayed, if you had permissions, is not displayed.
 * # We do the moral equivalent of obscuring it with black marker - think Mueller team, Individual #1, etc.
 * job.status.enum.jobStatusRedacted.label=Redacted
 * </pre>
 */export function job_status_enum_jobStatusRedacted_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusRedacted.label");}/**
 * <pre>
 * job.status.enum.jobStatusRedacted.toolTip=Redacted
 * </pre>
 */export function job_status_enum_jobStatusRedacted_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusRedacted.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusRunning.label=Running
 * </pre>
 */export function job_status_enum_jobStatusRunning_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusRunning.label");}/**
 * <pre>
 * job.status.enum.jobStatusRunning.toolTip=Running
 * </pre>
 */export function job_status_enum_jobStatusRunning_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusRunning.toolTip");}/**
 * <pre>
 * # These two PRs are the reason we can't just change Skip to Skipped right now...
 * # PR 127663: Daily Jobs: When group by Status, send status name, not label, so as to decouple from i18n
 * # PR 127665: Specify jobStatusSkipped.label as noun (Skipped) not verb (Skip)
 * job.status.enum.jobStatusSkipped.label=Skip
 * </pre>
 */export function job_status_enum_jobStatusSkipped_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSkipped.label");}/**
 * <pre>
 * job.status.enum.jobStatusSkipped.toolTip=Skipped
 * </pre>
 */export function job_status_enum_jobStatusSkipped_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSkipped.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusSkippedPast.label=Skipped Over
 * </pre>
 */export function job_status_enum_jobStatusSkippedPast_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSkippedPast.label");}/**
 * <pre>
 * job.status.enum.jobStatusSkippedPast.toolTip=Skipped Over
 * </pre>
 */export function job_status_enum_jobStatusSkippedPast_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSkippedPast.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusStarting.label=Starting
 * </pre>
 */export function job_status_enum_jobStatusStarting_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusStarting.label");}/**
 * <pre>
 * job.status.enum.jobStatusStarting.toolTip=Starting...
 * </pre>
 */export function job_status_enum_jobStatusStarting_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusStarting.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusSuccess.label=Succeeded
 * </pre>
 */export function job_status_enum_jobStatusSuccess_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSuccess.label");}/**
 * <pre>
 * job.status.enum.jobStatusSuccess.toolTip=Succeeded
 * </pre>
 */export function job_status_enum_jobStatusSuccess_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSuccess.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusSummarized.label=Summarized
 * </pre>
 */export function job_status_enum_jobStatusSummarized_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSummarized.label");}/**
 * <pre>
 * job.status.enum.jobStatusSummarized.toolTip=Summarized
 * </pre>
 */export function job_status_enum_jobStatusSummarized_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusSummarized.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusUnknown.label=Unknown
 * </pre>
 */export function job_status_enum_jobStatusUnknown_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusUnknown.label");}/**
 * <pre>
 * job.status.enum.jobStatusUnknown.toolTip=Unknown
 * </pre>
 */export function job_status_enum_jobStatusUnknown_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusUnknown.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusUnstarted.label=Upcoming
 * </pre>
 */export function job_status_enum_jobStatusUnstarted_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusUnstarted.label");}/**
 * <pre>
 * job.status.enum.jobStatusUnstarted.toolTip=Upcoming - scheduled start time has not yet arrived
 * </pre>
 */export function job_status_enum_jobStatusUnstarted_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusUnstarted.toolTip");}/**
 * <pre>
 * job.status.enum.jobStatusWaiting.label=Waiting
 * </pre>
 */export function job_status_enum_jobStatusWaiting_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusWaiting.label");}/**
 * <pre>
 * job.status.enum.jobStatusWaiting.toolTip=Waiting for file, event, resource, or another job
 * </pre>
 */export function job_status_enum_jobStatusWaiting_toolTip(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.jobStatusWaiting.toolTip");}/**
 * <pre>
 * job.status.enum.unstarted.label=Unstarted
 * </pre>
 */export function job_status_enum_unstarted_label(){return AbWebServices.i18n.getMessage("abweb","job.status.enum.unstarted.label");}/**
 * <pre>
 * job.status.failure.dispatcher.ignored.tooltip=Failure ignored
 * </pre>
 */export function job_status_failure_dispatcher_ignored_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.failure.dispatcher.ignored.tooltip");}/**
 * <pre>
 * job.status.failure.dispatcher.rerun.tooltip=Dispatcher job was rerun after failure
 * </pre>
 */export function job_status_failure_dispatcher_rerun_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.failure.dispatcher.rerun.tooltip");}/**
 * <pre>
 * job.status.failure.dispatcher.tooltip=Stopped or unable to start any jobs
 * </pre>
 */export function job_status_failure_dispatcher_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.failure.dispatcher.tooltip");}/**
 * <pre>
 * job.status.failure.ignored.tooltip=Failure ignored
 * </pre>
 */export function job_status_failure_ignored_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.failure.ignored.tooltip");}/**
 * <pre>
 * job.status.failure.rerun.tooltip=Job was rerun after failure
 * </pre>
 */export function job_status_failure_rerun_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.failure.rerun.tooltip");}/**
 * <pre>
 * job.status.running.dispatcher.tooltip=Has started at least one job; waiting to start others
 * </pre>
 */export function job_status_running_dispatcher_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.running.dispatcher.tooltip");}/**
 * <pre>
 * job.status.success.dispatcher.rerun.tooltip=Dispatcher job was rerun after success
 * </pre>
 */export function job_status_success_dispatcher_rerun_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.success.dispatcher.rerun.tooltip");}/**
 * <pre>
 * job.status.success.dispatcher.tooltip=Succeeded in starting at least one job
 * </pre>
 */export function job_status_success_dispatcher_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.success.dispatcher.tooltip");}/**
 * <pre>
 * job.status.success.rerun.tooltip=Job was rerun after success
 * </pre>
 */export function job_status_success_rerun_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.success.rerun.tooltip");}/**
 * <pre>
 * job.status.unstarted.tooltip=Scheduled start time has passed: Check Control>Center status
 * </pre>
 */export function job_status_unstarted_tooltip(){return AbWebServices.i18n.getMessage("abweb","job.status.unstarted.tooltip");}/**
 * <pre>
 * # {0} is TBD
 * job.status.waiting.tooltip={0}: Check Control>Center status
 * </pre>
 */export function job_status_waiting_tooltip(arg0){return AbWebServices.i18n.getMessage("abweb","job.status.waiting.tooltip",arg0);}/**
 * <pre>
 * label.WithSeparator={0}:
 * </pre>
 */export function label_withSeparator(arg0){return AbWebServices.i18n.getMessage("abweb","label.WithSeparator",arg0);}/**
 * <pre>
 * loading=Loading
 * </pre>
 */export function loading(){return AbWebServices.i18n.getMessage("abweb","loading");}/**
 * <pre>
 * loadingApplication=Loading application. Please wait...
 * </pre>
 */export function loadingApplication(){return AbWebServices.i18n.getMessage("abweb","loadingApplication");}/**
 * <pre>
 * locale.language.de=German
 * </pre>
 */export function locale_language_de(){return AbWebServices.i18n.getMessage("abweb","locale.language.de");}/**
 * <pre>
 * locale.language.en=English
 * </pre>
 */export function locale_language_en(){return AbWebServices.i18n.getMessage("abweb","locale.language.en");}/**
 * <pre>
 * locale.language.en-FR=English (French Formatting)
 * </pre>
 */export function locale_language_enFr(){return AbWebServices.i18n.getMessage("abweb","locale.language.en-FR");}/**
 * <pre>
 * locale.language.en-GB=English (British)
 * </pre>
 */export function locale_language_enGb(){return AbWebServices.i18n.getMessage("abweb","locale.language.en-GB");}/**
 * <pre>
 * locale.language.es=Spanish
 * </pre>
 */export function locale_language_es(){return AbWebServices.i18n.getMessage("abweb","locale.language.es");}/**
 * <pre>
 * locale.language.fr=French
 * </pre>
 */export function locale_language_fr(){return AbWebServices.i18n.getMessage("abweb","locale.language.fr");}/**
 * <pre>
 * locale.language.it=Italian
 * </pre>
 */export function locale_language_it(){return AbWebServices.i18n.getMessage("abweb","locale.language.it");}/**
 * <pre>
 * locale.language.ja=Japanese
 * </pre>
 */export function locale_language_ja(){return AbWebServices.i18n.getMessage("abweb","locale.language.ja");}/**
 * <pre>
 * locale.language.zh-CN=Simplified Chinese
 * </pre>
 */export function locale_language_zhCn(){return AbWebServices.i18n.getMessage("abweb","locale.language.zh-CN");}/**
 * <pre>
 * localePreferenceDlg.info=Changing the language will reload the browser tab (you will lose any unsaved work).
 * </pre>
 */export function localePreferenceDlg_info(){return AbWebServices.i18n.getMessage("abweb","localePreferenceDlg.info");}/**
 * <pre>
 * localePreferenceDlg.prompt=Choose the interface language:
 * </pre>
 */export function localePreferenceDlg_prompt(){return AbWebServices.i18n.getMessage("abweb","localePreferenceDlg.prompt");}/**
 * <pre>
 * localePreferenceDlg.title=Choose Language
 * </pre>
 */export function localePreferenceDlg_title(){return AbWebServices.i18n.getMessage("abweb","localePreferenceDlg.title");}/**
 * <pre>
 * logOut=Log out
 * </pre>
 */export function logOut(){return AbWebServices.i18n.getMessage("abweb","logOut");}/**
 * <pre>
 * loginDlg.failedAuthenticationOrAuthorizationMessage=An authentication or authorization error occurred. Please contact your system administrator or try again.
 * </pre>
 */export function loginDlg_failedAuthenticationOrAuthorizationMessage(){return AbWebServices.i18n.getMessage("abweb","loginDlg.failedAuthenticationOrAuthorizationMessage");}/**
 * <pre>
 * loginDlg.invalidUsernameOrPasswordError=Invalid username or password. Please try again.
 * </pre>
 */export function loginDlg_invalidUsernameOrPasswordError(){return AbWebServices.i18n.getMessage("abweb","loginDlg.invalidUsernameOrPasswordError");}/**
 * <pre>
 * loginDlg.serverUnreachable=The server cannot be reached.
 * </pre>
 */export function loginDlg_serverUnreachable(){return AbWebServices.i18n.getMessage("abweb","loginDlg.serverUnreachable");}/**
 * <pre>
 * loginDlg.sessionLostError=Current session was lost. Please log in.
 * </pre>
 */export function loginDlg_sessionLostError(){return AbWebServices.i18n.getMessage("abweb","loginDlg.sessionLostError");}/**
 * <pre>
 * maxLengthValidation=Value must contain fewer than {0} characters
 * </pre>
 */export function maxLengthValidation(arg0){return AbWebServices.i18n.getMessage("abweb","maxLengthValidation",arg0);}/**
 * <pre>
 * # all resource keys beginning with "navigation" are intended to be used by navigation controls
 * # for example, a toolbar may have a "back" button to return to the previous page
 * navigation.back=Back
 * </pre>
 */export function navigation_back(){return AbWebServices.i18n.getMessage("abweb","navigation.back");}/**
 * <pre>
 * navigation.return=Return
 * </pre>
 */export function navigation_return(){return AbWebServices.i18n.getMessage("abweb","navigation.return");}/**
 * <pre>
 * next=Next
 * </pre>
 */export function next(){return AbWebServices.i18n.getMessage("abweb","next");}/**
 * <pre>
 * no=No
 * </pre>
 */export function no(){return AbWebServices.i18n.getMessage("abweb","no");}/**
 * <pre>
 * noData=No data to display
 * </pre>
 */export function noData(){return AbWebServices.i18n.getMessage("abweb","noData");}/**
 * <pre>
 * notification.severity.error=Error
 * </pre>
 */export function notification_severity_error(){return AbWebServices.i18n.getMessage("abweb","notification.severity.error");}/**
 * <pre>
 * notification.severity.info=Information
 * </pre>
 */export function notification_severity_info(){return AbWebServices.i18n.getMessage("abweb","notification.severity.info");}/**
 * <pre>
 * notification.severity.unseen=Unseen
 * </pre>
 */export function notification_severity_unseen(){return AbWebServices.i18n.getMessage("abweb","notification.severity.unseen");}/**
 * <pre>
 * notification.severity.warning=Warning
 * </pre>
 */export function notification_severity_warning(){return AbWebServices.i18n.getMessage("abweb","notification.severity.warning");}/**
 * <pre>
 * ok=OK
 * </pre>
 */export function ok(){return AbWebServices.i18n.getMessage("abweb","ok");}/**
 * <pre>
 * packageForSupport.preparingToDownloadPackageMessage=Preparing package for download...
 * </pre>
 */export function packageForSupport_preparingToDownloadPackageMessage(){return AbWebServices.i18n.getMessage("abweb","packageForSupport.preparingToDownloadPackageMessage");}/**
 * <pre>
 * packageForSupport.title=Package for Support Download
 * </pre>
 */export function packageForSupport_title(){return AbWebServices.i18n.getMessage("abweb","packageForSupport.title");}/**
 * <pre>
 * paste=Paste
 * </pre>
 */export function paste(){return AbWebServices.i18n.getMessage("abweb","paste");}/**
 * <pre>
 * pleaseWait=Please wait
 * </pre>
 */export function pleaseWait(){return AbWebServices.i18n.getMessage("abweb","pleaseWait");}/**
 * <pre>
 * previous=Previous
 * </pre>
 */export function previous(){return AbWebServices.i18n.getMessage("abweb","previous");}/**
 * <pre>
 * printButton.tooltip=Print
 * </pre>
 */export function printButton_tooltip(){return AbWebServices.i18n.getMessage("abweb","printButton.tooltip");}/**
 * <pre>
 * # Baseline vs. tip value. Call baseline value "Previous value".
 * propertyItemCmp.changes1=Previous value:
{0}
 * </pre>
 */export function propertyItemCmp_changes1(arg0){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.changes1",arg0);}/**
 * <pre>
 * # Changeset vs. local change. Call changeset value "Previous value".
 * propertyItemCmp.changes1a=Previous value:
{0}
 * </pre>
 */export function propertyItemCmp_changes1a(arg0){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.changes1a",arg0);}/**
 * <pre>
 * # Baseline vs. changeset vs. local change. Call baseline value "Published value".
 * propertyItemCmp.changes2=Changeset value:
{0}

Published value:
{1}
 * </pre>
 */export function propertyItemCmp_changes2(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.changes2",arg0,arg1);}/**
 * <pre>
 * propertyItemCmp.itemAdded=Item added
 * </pre>
 */export function propertyItemCmp_itemAdded(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.itemAdded");}/**
 * <pre>
 * propertyItemCmp.itemRemoved=Item removed
 * </pre>
 */export function propertyItemCmp_itemRemoved(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.itemRemoved");}/**
 * <pre>
 * propertyItemCmp.limitedTextLessLink=less
 * </pre>
 */export function propertyItemCmp_limitedTextLessLink(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.limitedTextLessLink");}/**
 * <pre>
 * propertyItemCmp.limitedTextMoreLink=more
 * </pre>
 */export function propertyItemCmp_limitedTextMoreLink(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.limitedTextMoreLink");}/**
 * <pre>
 * propertyItemCmp.newValueTooltip=New value
 * </pre>
 */export function propertyItemCmp_newValueTooltip(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.newValueTooltip");}/**
 * <pre>
 * propertyItemCmp.oldValueTooltip=Previous value
 * </pre>
 */export function propertyItemCmp_oldValueTooltip(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.oldValueTooltip");}/**
 * <pre>
 * propertyItemCmp.showDifferencesTooltip=Compare new and previous values
 * </pre>
 */export function propertyItemCmp_showDifferencesTooltip(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.showDifferencesTooltip");}/**
 * <pre>
 * propertyItemCmp.textDecoratorTooltip=Text value has changed
 * </pre>
 */export function propertyItemCmp_textDecoratorTooltip(){return AbWebServices.i18n.getMessage("abweb","propertyItemCmp.textDecoratorTooltip");}/**
 * <pre>
 * rangeMaxValidation=Value must be less than or equal to {0}
 * </pre>
 */export function rangeMaxValidation(arg0){return AbWebServices.i18n.getMessage("abweb","rangeMaxValidation",arg0);}/**
 * <pre>
 * rangeMinValidation=Value must be greater than or equal to {0}
 * </pre>
 */export function rangeMinValidation(arg0){return AbWebServices.i18n.getMessage("abweb","rangeMinValidation",arg0);}/**
 * <pre>
 * regExpValidation=Value does not match expected pattern '{0}'
 * </pre>
 */export function regExpValidation(arg0){return AbWebServices.i18n.getMessage("abweb","regExpValidation",arg0);}/**
 * <pre>
 * remove=Remove
 * </pre>
 */export function remove(){return AbWebServices.i18n.getMessage("abweb","remove");}/**
 * <pre>
 * required=Field is required
 * </pre>
 */export function required(){return AbWebServices.i18n.getMessage("abweb","required");}/**
 * <pre>
 * reset.setting=Reset
 * </pre>
 */export function reset_setting(){return AbWebServices.i18n.getMessage("abweb","reset.setting");}/**
 * <pre>
 * retry=Retry
 * </pre>
 */export function retry(){return AbWebServices.i18n.getMessage("abweb","retry");}/**
 * <pre>
 * revert=Revert
 * </pre>
 */export function revert(){return AbWebServices.i18n.getMessage("abweb","revert");}/**
 * <pre>
 * rpc.missedMessages=Lost connection to server, please reload the page to reconnect.
 * </pre>
 */export function rpc_missedMessages(){return AbWebServices.i18n.getMessage("abweb","rpc.missedMessages");}/**
 * <pre>
 * rpcServiceError.cachedResourcesRequireGet=Requests for cacheable resources must be of type GET
 * </pre>
 */export function rpcServiceError_cachedResourcesRequireGet(){return AbWebServices.i18n.getMessage("abweb","rpcServiceError.cachedResourcesRequireGet");}/**
 * <pre>
 * rpcServiceError.unexpectedDynamicParameterEquality=Local and remote dynamic cache bust parameters should differ, but both equal '{0}'
 * </pre>
 */export function rpcServiceError_unexpectedDynamicParameterEquality(arg0){return AbWebServices.i18n.getMessage("abweb","rpcServiceError.unexpectedDynamicParameterEquality",arg0);}/**
 * <pre>
 * rpcServiceError.unexpectedResponseHeader=Expected response header 'Content-Type' to either be empty or to contain '{0}' but was: '{1}'
 * </pre>
 */export function rpcServiceError_unexpectedResponseHeader(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","rpcServiceError.unexpectedResponseHeader",arg0,arg1);}/**
 * <pre>
 * rpcServiceError.unhandledRpcMethodType=Only handle 'post', 'put', 'patch', 'get' and 'delete' rpc method types but received: '{0}'
 * </pre>
 */export function rpcServiceError_unhandledRpcMethodType(arg0){return AbWebServices.i18n.getMessage("abweb","rpcServiceError.unhandledRpcMethodType",arg0);}/**
 * <pre>
 * rpcServiceError.unknownRequestMethodType=Unknown MethodType value: '{0}'
 * </pre>
 */export function rpcServiceError_unknownRequestMethodType(arg0){return AbWebServices.i18n.getMessage("abweb","rpcServiceError.unknownRequestMethodType",arg0);}/**
 * <pre>
 * run=Run
 * </pre>
 */export function run(){return AbWebServices.i18n.getMessage("abweb","run");}/**
 * <pre>
 * save=Save
 * </pre>
 */export function save(){return AbWebServices.i18n.getMessage("abweb","save");}/**
 * <pre>
 * saveAs=Save As...
 * </pre>
 */export function saveAs(){return AbWebServices.i18n.getMessage("abweb","saveAs");}/**
 * <pre>
 * saveMore=Save...
 * </pre>
 */export function saveMore(){return AbWebServices.i18n.getMessage("abweb","saveMore");}/**
 * <pre>
 * select=Select
 * </pre>
 */export function select(){return AbWebServices.i18n.getMessage("abweb","select");}/**
 * <pre>
 * showDetails=Show Details
 * </pre>
 */export function showDetails(){return AbWebServices.i18n.getMessage("abweb","showDetails");}/**
 * <pre>
 * spaceTheme.aqua.label=Aqua
 * </pre>
 */export function spaceTheme_aqua_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.aqua.label");}/**
 * <pre>
 * spaceTheme.aquaBlue.label=Aqua Blue
 * </pre>
 */export function spaceTheme_aquaBlue_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.aquaBlue.label");}/**
 * <pre>
 * spaceTheme.aquaIndigo.label=Aqua Indigo
 * </pre>
 */export function spaceTheme_aquaIndigo_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.aquaIndigo.label");}/**
 * <pre>
 * spaceTheme.blueGreen.label=Blue Green
 * </pre>
 */export function spaceTheme_blueGreen_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.blueGreen.label");}/**
 * <pre>
 * spaceTheme.bluePink.label=Blue Pink
 * </pre>
 */export function spaceTheme_bluePink_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.bluePink.label");}/**
 * <pre>
 * spaceTheme.bluePurple.label=Blue Purple
 * </pre>
 */export function spaceTheme_bluePurple_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.bluePurple.label");}/**
 * <pre>
 * spaceTheme.burgundy.label=Burgundy
 * </pre>
 */export function spaceTheme_burgundy_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.burgundy.label");}/**
 * <pre>
 * spaceTheme.default.label=Default
 * </pre>
 */export function spaceTheme_default_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.default.label");}/**
 * <pre>
 * spaceTheme.emerald.label=Emerald
 * </pre>
 */export function spaceTheme_emerald_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.emerald.label");}/**
 * <pre>
 * spaceTheme.greenBlue.label=Green Blue
 * </pre>
 */export function spaceTheme_greenBlue_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.greenBlue.label");}/**
 * <pre>
 * spaceTheme.indigo.label=Indigo
 * </pre>
 */export function spaceTheme_indigo_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.indigo.label");}/**
 * <pre>
 * spaceTheme.indigoAqua.label=Indigo Aqua
 * </pre>
 */export function spaceTheme_indigoAqua_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.indigoAqua.label");}/**
 * <pre>
 * spaceTheme.indigoBlue.label=Indigo Blue
 * </pre>
 */export function spaceTheme_indigoBlue_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.indigoBlue.label");}/**
 * <pre>
 * spaceTheme.indigoPurple.label=Indigo Purple
 * </pre>
 */export function spaceTheme_indigoPurple_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.indigoPurple.label");}/**
 * <pre>
 * spaceTheme.orangePink.label=Orange Pink
 * </pre>
 */export function spaceTheme_orangePink_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.orangePink.label");}/**
 * <pre>
 * spaceTheme.pinkBlue.label=Pink Blue
 * </pre>
 */export function spaceTheme_pinkBlue_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.pinkBlue.label");}/**
 * <pre>
 * spaceTheme.pinkOrange.label=Pink Orange
 * </pre>
 */export function spaceTheme_pinkOrange_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.pinkOrange.label");}/**
 * <pre>
 * spaceTheme.purpleBlue.label=Purple Blue
 * </pre>
 */export function spaceTheme_purpleBlue_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.purpleBlue.label");}/**
 * <pre>
 * spaceTheme.purpleIndigo.label=Purple Indigo
 * </pre>
 */export function spaceTheme_purpleIndigo_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.purpleIndigo.label");}/**
 * <pre>
 * spaceTheme.raspberry.label=Raspberry
 * </pre>
 */export function spaceTheme_raspberry_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.raspberry.label");}/**
 * <pre>
 * spaceTheme.royalBlue.label=Royal Blue
 * </pre>
 */export function spaceTheme_royalBlue_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.royalBlue.label");}/**
 * <pre>
 * spaceTheme.steel.label=Steel
 * </pre>
 */export function spaceTheme_steel_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.steel.label");}/**
 * <pre>
 * spaceTheme.tealBlue.label=Teal Blue
 * </pre>
 */export function spaceTheme_tealBlue_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.tealBlue.label");}/**
 * <pre>
 * spaceTheme.violet.label=Violet
 * </pre>
 */export function spaceTheme_violet_label(){return AbWebServices.i18n.getMessage("abweb","spaceTheme.violet.label");}/**
 * <pre>
 * success=Success
 * </pre>
 */export function success(){return AbWebServices.i18n.getMessage("abweb","success");}/**
 * <pre>
 * tabularGrid.appendChildRowTooltip=Append child row
 * </pre>
 */export function tabularGrid_appendChildRowTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.appendChildRowTooltip");}/**
 * <pre>
 * tabularGrid.appendRowTooltip=Append row
 * </pre>
 */export function tabularGrid_appendRowTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.appendRowTooltip");}/**
 * <pre>
 * tabularGrid.applySortLabel=Sort
 * </pre>
 */export function tabularGrid_applySortLabel(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.applySortLabel");}/**
 * <pre>
 * tabularGrid.applySortTooltip=Manage sort order of data
 * </pre>
 */export function tabularGrid_applySortTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.applySortTooltip");}/**
 * <pre>
 * tabularGrid.applyTooltip=Save changes and remain in edit mode
 * </pre>
 */export function tabularGrid_applyTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.applyTooltip");}/**
 * <pre>
 * tabularGrid.cancelTooltip=Cancel all changes and return to read-only mode
 * </pre>
 */export function tabularGrid_cancelTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.cancelTooltip");}/**
 * <pre>
 * tabularGrid.clearFiltersTooltip=Clear all filters
 * </pre>
 */export function tabularGrid_clearFiltersTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.clearFiltersTooltip");}/**
 * <pre>
 * tabularGrid.collapseAllNodesTooltip=Collapse all nodes
 * </pre>
 */export function tabularGrid_collapseAllNodesTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.collapseAllNodesTooltip");}/**
 * <pre>
 * tabularGrid.copyTooltip=Copy (Ctrl+C)
 * </pre>
 */export function tabularGrid_copyTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.copyTooltip");}/**
 * <pre>
 * tabularGrid.deleteRowsTooltip=Delete selected rows (Delete)
 * </pre>
 */export function tabularGrid_deleteRowsTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.deleteRowsTooltip");}/**
 * <pre>
 * tabularGrid.differencesTooltip=Show differences between current cell value and previous value
 * </pre>
 */export function tabularGrid_differencesTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.differencesTooltip");}/**
 * <pre>
 * tabularGrid.downloadToSpreadsheetLabel=Download to Spreadsheet
 * </pre>
 */export function tabularGrid_downloadToSpreadsheetLabel(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.downloadToSpreadsheetLabel");}/**
 * <pre>
 * tabularGrid.expandAllNodesTooltip=Expand all nodes
 * </pre>
 */export function tabularGrid_expandAllNodesTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.expandAllNodesTooltip");}/**
 * <pre>
 * tabularGrid.filterTextLabel=Overall text filter:
 * </pre>
 */export function tabularGrid_filterTextLabel(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.filterTextLabel");}/**
 * <pre>
 * tabularGrid.filterTextPlaceholder=Filter by...
 * </pre>
 */export function tabularGrid_filterTextPlaceholder(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.filterTextPlaceholder");}/**
 * <pre>
 * tabularGrid.filterTextTooltip=Displays rows with matching content
 * </pre>
 */export function tabularGrid_filterTextTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.filterTextTooltip");}/**
 * <pre>
 * tabularGrid.filterTextUncommittedTooltip=Hit RETURN to commit
 * </pre>
 */export function tabularGrid_filterTextUncommittedTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.filterTextUncommittedTooltip");}/**
 * <pre>
 * tabularGrid.filtersTooltip=Manage filters
 * </pre>
 */export function tabularGrid_filtersTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.filtersTooltip");}/**
 * <pre>
 * tabularGrid.filtersTooltipDisabled=No filterable columns
 * </pre>
 */export function tabularGrid_filtersTooltipDisabled(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.filtersTooltipDisabled");}/**
 * <pre>
 * tabularGrid.filtersTooltipDisabledEditMode=Filtering is disabled while editing
 * </pre>
 */export function tabularGrid_filtersTooltipDisabledEditMode(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.filtersTooltipDisabledEditMode");}/**
 * <pre>
 * tabularGrid.indentRows=Indent rows (change parentage) (Ctrl+arrow right)
 * </pre>
 */export function tabularGrid_indentRows(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.indentRows");}/**
 * <pre>
 * tabularGrid.infoIconLabel={0} rows
 * </pre>
 */export function tabularGrid_infoIconLabel(arg0){return AbWebServices.i18n.getMessage("abweb","tabularGrid.infoIconLabel",arg0);}/**
 * <pre>
 * tabularGrid.infoIconTooltip=Displaying {0} rows
 * </pre>
 */export function tabularGrid_infoIconTooltip(arg0){return AbWebServices.i18n.getMessage("abweb","tabularGrid.infoIconTooltip",arg0);}/**
 * <pre>
 * tabularGrid.insertRowsBelowTooltip=Insert rows below (Ctrl+Insert)
 * </pre>
 */export function tabularGrid_insertRowsBelowTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.insertRowsBelowTooltip");}/**
 * <pre>
 * tabularGrid.insertRowsTooltip=Insert rows above (Insert)
 * </pre>
 */export function tabularGrid_insertRowsTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.insertRowsTooltip");}/**
 * <pre>
 * tabularGrid.manageColumnsLabel=Display
 * </pre>
 */export function tabularGrid_manageColumnsLabel(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.manageColumnsLabel");}/**
 * <pre>
 * tabularGrid.manageColumnsTooltip=Hide columns and manage column order
 * </pre>
 */export function tabularGrid_manageColumnsTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.manageColumnsTooltip");}/**
 * <pre>
 * tabularGrid.manageFiltersLabel=Filter
 * </pre>
 */export function tabularGrid_manageFiltersLabel(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.manageFiltersLabel");}/**
 * <pre>
 * tabularGrid.outdentRows=Outdent rows (change parentage) (Ctrl+arrow left)
 * </pre>
 */export function tabularGrid_outdentRows(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.outdentRows");}/**
 * <pre>
 * tabularGrid.pasteTooltip=Paste (Ctrl+V)
 * </pre>
 */export function tabularGrid_pasteTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.pasteTooltip");}/**
 * <pre>
 * tabularGrid.preparingToDownloadSpreadsheetMessage=Preparing spreadsheet for download...
 * </pre>
 */export function tabularGrid_preparingToDownloadSpreadsheetMessage(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.preparingToDownloadSpreadsheetMessage");}/**
 * <pre>
 * tabularGrid.reparentAppendParentTooltip=For append, the selected record cannot be the direct parent of the rows to be moved.
 * </pre>
 */export function tabularGrid_reparentAppendParentTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.reparentAppendParentTooltip");}/**
 * <pre>
 * tabularGrid.reparentChildTooltip=Selected record cannot be a child or descendant of rows to be moved.
 * </pre>
 */export function tabularGrid_reparentChildTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.reparentChildTooltip");}/**
 * <pre>
 * tabularGrid.reparentDeletedTooltip=Selected record cannot be marked for deletion.
 * </pre>
 */export function tabularGrid_reparentDeletedTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.reparentDeletedTooltip");}/**
 * <pre>
 * tabularGrid.reparentInsertSiblingTooltip=For insert, the selected record cannot be a sibling of the rows to be moved.
 * </pre>
 */export function tabularGrid_reparentInsertSiblingTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.reparentInsertSiblingTooltip");}/**
 * <pre>
 * tabularGrid.reparentRowsTooltip=Move selected rows
 * </pre>
 */export function tabularGrid_reparentRowsTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.reparentRowsTooltip");}/**
 * <pre>
 * tabularGrid.reparentTooltip=Select a single record to be the new parent or insertion point.
 * </pre>
 */export function tabularGrid_reparentTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.reparentTooltip");}/**
 * <pre>
 * tabularGrid.resetSortLabel=Reset sort
 * </pre>
 */export function tabularGrid_resetSortLabel(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.resetSortLabel");}/**
 * <pre>
 * tabularGrid.resetSortTooltip=Reset sort
 * </pre>
 */export function tabularGrid_resetSortTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.resetSortTooltip");}/**
 * <pre>
 * tabularGrid.revertChangesTooltip=Revert changes to selected items (Ctrl+Z)
 * </pre>
 */export function tabularGrid_revertChangesTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.revertChangesTooltip");}/**
 * <pre>
 * tabularGrid.revertWarning=Cannot revert selected records marked for deletion.
Only the top-most deleted record can be reverted.
 * </pre>
 */export function tabularGrid_revertWarning(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.revertWarning");}/**
 * <pre>
 * tabularGrid.saveTooltip=Save changes and return to read-only mode (Ctrl+S)
 * </pre>
 */export function tabularGrid_saveTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.saveTooltip");}/**
 * <pre>
 * tabularGrid.saveValidationErrors=Cannot perform save because at least one record contains validation errors. Correct these errors and try again.
 * </pre>
 */export function tabularGrid_saveValidationErrors(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.saveValidationErrors");}/**
 * <pre>
 * tabularGrid.sortedHierarchicalDataWarningTooltip=Hierarchical data is sorted. Click Reset Sort button to return to hierarchical mode
 * </pre>
 */export function tabularGrid_sortedHierarchicalDataWarningTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.sortedHierarchicalDataWarningTooltip");}/**
 * <pre>
 * tabularGrid.wrapTextFalseTooltip=Displaying single-line row content
 * </pre>
 */export function tabularGrid_wrapTextFalseTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.wrapTextFalseTooltip");}/**
 * <pre>
 * tabularGrid.wrapTextLabel=Wrap text
 * </pre>
 */export function tabularGrid_wrapTextLabel(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.wrapTextLabel");}/**
 * <pre>
 * tabularGrid.wrapTextTrueTooltip=Displaying multi-line row content
 * </pre>
 */export function tabularGrid_wrapTextTrueTooltip(){return AbWebServices.i18n.getMessage("abweb","tabularGrid.wrapTextTrueTooltip");}/**
 * <pre>
 * textEditor.insertObjectRef=Insert object reference link
 * </pre>
 */export function textEditor_insertObjectRef(){return AbWebServices.i18n.getMessage("abweb","textEditor.insertObjectRef");}/**
 * <pre>
 * textEditor.pasteObjectRef=Paste object reference link
 * </pre>
 */export function textEditor_pasteObjectRef(){return AbWebServices.i18n.getMessage("abweb","textEditor.pasteObjectRef");}/**
 * <pre>
 * textEditor.showHtmlEditor=Show full HTML editor dialog
 * </pre>
 */export function textEditor_showHtmlEditor(){return AbWebServices.i18n.getMessage("abweb","textEditor.showHtmlEditor");}/**
 * <pre>
 * textEditorDlg.title=Edit HTML
 * </pre>
 */export function textEditorDlg_title(){return AbWebServices.i18n.getMessage("abweb","textEditorDlg.title");}/**
 * <pre>
 * timediff.days={0} days
 * </pre>
 */export function timediff_days(arg0){return AbWebServices.i18n.getMessage("abweb","timediff.days",arg0);}/**
 * <pre>
 * timediff.hours={0} hours
 * </pre>
 */export function timediff_hours(arg0){return AbWebServices.i18n.getMessage("abweb","timediff.hours",arg0);}/**
 * <pre>
 * timediff.minutes={0} minutes
 * </pre>
 */export function timediff_minutes(arg0){return AbWebServices.i18n.getMessage("abweb","timediff.minutes",arg0);}/**
 * <pre>
 * timediff.months={0} months
 * </pre>
 */export function timediff_months(arg0){return AbWebServices.i18n.getMessage("abweb","timediff.months",arg0);}/**
 * <pre>
 * timediff.oneDay=1 day
 * </pre>
 */export function timediff_oneDay(){return AbWebServices.i18n.getMessage("abweb","timediff.oneDay");}/**
 * <pre>
 * timediff.oneHour=1 hour
 * </pre>
 */export function timediff_oneHour(){return AbWebServices.i18n.getMessage("abweb","timediff.oneHour");}/**
 * <pre>
 * timediff.oneMinute=1 minute
 * </pre>
 */export function timediff_oneMinute(){return AbWebServices.i18n.getMessage("abweb","timediff.oneMinute");}/**
 * <pre>
 * timediff.oneMonth=1 month
 * </pre>
 */export function timediff_oneMonth(){return AbWebServices.i18n.getMessage("abweb","timediff.oneMonth");}/**
 * <pre>
 * # The following pertains to a difference between two dates/times, as in 1 hour 20 minutes 32 seconds
 * timediff.oneSecond=1 second
 * </pre>
 */export function timediff_oneSecond(){return AbWebServices.i18n.getMessage("abweb","timediff.oneSecond");}/**
 * <pre>
 * timediff.oneYear=1 year
 * </pre>
 */export function timediff_oneYear(){return AbWebServices.i18n.getMessage("abweb","timediff.oneYear");}/**
 * <pre>
 * timediff.seconds={0} seconds
 * </pre>
 */export function timediff_seconds(arg0){return AbWebServices.i18n.getMessage("abweb","timediff.seconds",arg0);}/**
 * <pre>
 * timediff.years={0} years
 * </pre>
 */export function timediff_years(arg0){return AbWebServices.i18n.getMessage("abweb","timediff.years",arg0);}/**
 * <pre>
 * tree.errorDetails=Error Details
 * </pre>
 */export function tree_errorDetails(){return AbWebServices.i18n.getMessage("abweb","tree.errorDetails");}/**
 * <pre>
 * tree.loading=Loading...
 * </pre>
 */export function tree_loading(){return AbWebServices.i18n.getMessage("abweb","tree.loading");}/**
 * <pre>
 * tree.loading.cancelled=Cancelled
 * </pre>
 */export function tree_loading_cancelled(){return AbWebServices.i18n.getMessage("abweb","tree.loading.cancelled");}/**
 * <pre>
 * tree.tryAgain=Try Again
 * </pre>
 */export function tree_tryAgain(){return AbWebServices.i18n.getMessage("abweb","tree.tryAgain");}/**
 * <pre>
 * uirevert0=Revert to previous value
 * </pre>
 */export function uirevert0(){return AbWebServices.i18n.getMessage("abweb","uirevert0");}/**
 * <pre>
 * uirevert1=Revert to previous value:
{0}
 * </pre>
 */export function uirevert1(arg0){return AbWebServices.i18n.getMessage("abweb","uirevert1",arg0);}/**
 * <pre>
 * uirevert2=Revert to changeset value:
{0}

Published value:
{1}
 * </pre>
 */export function uirevert2(arg0,arg1){return AbWebServices.i18n.getMessage("abweb","uirevert2",arg0,arg1);}/**
 * <pre>
 * undefined.boolean.tooltip=Current value is undefined
 * </pre>
 */export function undefined_boolean_tooltip(){return AbWebServices.i18n.getMessage("abweb","undefined.boolean.tooltip");}/**
 * <pre>
 * unsupportedFeature.title=Unsupported Feature
 * </pre>
 */export function unsupportedFeature_title(){return AbWebServices.i18n.getMessage("abweb","unsupportedFeature.title");}/**
 * <pre>
 * update=Update
 * </pre>
 */export function update(){return AbWebServices.i18n.getMessage("abweb","update");}/**
 * <pre>
 * warning=Warning
 * </pre>
 */export function warning(){return AbWebServices.i18n.getMessage("abweb","warning");}/**
 * <pre>
 * yes=Yes
 * </pre>
 */export function yes(){return AbWebServices.i18n.getMessage("abweb","yes");}/**
 * <pre>
 * zoomControl.zoomFitButton.label=Fit
 * </pre>
 */export function zoomControl_zoomFitButton_label(){return AbWebServices.i18n.getMessage("abweb","zoomControl.zoomFitButton.label");}/**
 * <pre>
 * zoomControl.zoomFitButton.tooltip=Zoom to fit
 * </pre>
 */export function zoomControl_zoomFitButton_tooltip(){return AbWebServices.i18n.getMessage("abweb","zoomControl.zoomFitButton.tooltip");}/**
 * <pre>
 * zoomControl.zoomFullButton.label=Reset
 * </pre>
 */export function zoomControl_zoomFullButton_label(){return AbWebServices.i18n.getMessage("abweb","zoomControl.zoomFullButton.label");}/**
 * <pre>
 * zoomControl.zoomFullButton.tooltip=Zoom to 100%
 * </pre>
 */export function zoomControl_zoomFullButton_tooltip(){return AbWebServices.i18n.getMessage("abweb","zoomControl.zoomFullButton.tooltip");}/**
 * <pre>
 * zoomControl.zoomInButton.tooltip=Zoom in
 * </pre>
 */export function zoomControl_zoomInButton_tooltip(){return AbWebServices.i18n.getMessage("abweb","zoomControl.zoomInButton.tooltip");}/**
 * <pre>
 * zoomControl.zoomOutButton.tooltip=Zoom out
 * </pre>
 */export function zoomControl_zoomOutButton_tooltip(){return AbWebServices.i18n.getMessage("abweb","zoomControl.zoomOutButton.tooltip");}
//# sourceMappingURL=AbWebResources.js.map
